/** Base Fetch Actions */
export const FETCH_SYSTEM_WEBHOOKS_REQUEST = 'FETCH_SYSTEM_WEBHOOKS_REQUEST' as const;
export const FETCH_SYSTEM_WEBHOOKS_RESPONSE = 'FETCH_SYSTEM_WEBHOOKS_RESPONSE' as const;

/** Base Create Actions */
export const CREATE_SYSTEM_WEBHOOK_REQUEST = 'CREATE_SYSTEM_WEBHOOKS_REQUEST' as const;
export const CREATE_SYSTEM_WEBHOOK_RESPONSE = 'CREATE_SYSTEM_WEBHOOKS_RESPONSE' as const;

/** Base Update Actions */
export const UPDATE_SYSTEM_WEBHOOK_REQUEST = 'UPDATE_SYSTEM_WEBHOOK_REQUEST' as const;
export const UPDATE_SYSTEM_WEBHOOK_RESPONSE = 'UPDATE_SYSTEM_WEBHOOK_RESPONSE' as const;

/** Base Delete Actions */
export const DELETE_SYSTEM_WEBHOOK_REQUEST = 'DELETE_SYSTEM_WEBHOOK_REQUEST' as const;
export const DELETE_SYSTEM_WEBHOOK_RESPONSE = 'DELETE_SYSTEM_WEBHOOK_RESPONSE' as const;

export const SYSTEM_WEBHOOK_ERROR = 'SYSTEM_WEBHOOK_ERROR' as const;
export const VALIDATE_SYSTEM_WEBHOOK_REQUEST = 'VALIDATE_SYSTEM_WEBHOOK_REQUEST' as const;
